export default __webpack_public_path__ + "static/media/ACE.eb66e057.jpeg";